import { App } from 'antd';
import { MessageInstance } from 'antd/lib/message/interface';

type THookRes = {
    message: MessageInstance;
};

export const useMessage = (): THookRes => {
    const { message } = App.useApp();

    return {
        message,
    };
};
